import {cs} from "../../../../../../../../../../react/chain-services";
import {csArr} from "../../../../../../../../../../react/cs-arr";
import {ZipCode} from "./zip-code/zip-code";
import {City} from "./city/city";

export const SelectTargetForms = ({next}) => cs(
    ["forms", ({}, next) => csArr(
        formTypes.map(({type, control}) => (
            (next) => cs(
                ["control", (_, next) => control({
                    next,
                })],
                ({control}) => next({
                    type, control,
                })
            )
        )),
        next
    )],
    ({forms}) => next({
        getForm: (type) => type && forms.find((form) => form.type === type).control,
    }),
);

const formTypes = [
    {
        type: "zip",
        control: ZipCode,
    },
    {
        type: "state",
        control: City,
    },
];